import AbsComponent from "./AbsComponent";
import Abilities from "./character/Abilities";
import AbilitiesPoint from "./character/AbilitiesPoint";
import CharGemItem from "./character/CharGemItem";
import CharHeader from "./character/CharHeader";
import CharLoadData from "./character/CharLoadData";
import Equipments from "./character/Equipments";

export default class CharCompare extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        this.charDataLoader = new CharLoadData(_store);
        this.headerMe = new CharHeader('CharHeader', this.store, this.actions, this.router, '', _l10n);
        this.headerCo = new CharHeader('CharHeader', this.store, this.actions, this.router, '', _l10n);

        this.equipMe = new Equipments('Equipments', this.store, this.actions, this.router, '', _l10n);
        this.equipCo = new Equipments('Equipments', this.store, this.actions, this.router, '', _l10n);

        this.gemsMe = new CharGemItem('CharGemItem', this.store, this.actions, this.router, '', _l10n);
        this.gemsCo = new CharGemItem('CharGemItem', this.store, this.actions, this.router, '', _l10n);

        this.abilitiesPointMe = new AbilitiesPoint('AbilitiesPoint', this.store, this.actions, this.router, '#compare .compare-char-a .info-ability', _l10n);
        this.abilitiesPointCo = new AbilitiesPoint('AbilitiesPoint', this.store, this.actions, this.router, '#compare .compare-char-b .info-ability', _l10n);

        this.abilitiesMe = new Abilities('Abilities', this.store, this.actions, this.router, '', _l10n);
        this.abilitiesCo = new Abilities('Abilities', this.store, this.actions, this.router, '', _l10n);

        const watchCom = this.watch(this.store.getState, 'compare', this.isEqual);
        this.store.subscribe( watchCom( this.loadData.bind(this) ) );

        this.addEvents();
    }

    loadData(_newVal, _oldVal, _path){
        if (_newVal==='true') {
            this.charDataLoader.loadCompareData( window.myChar.name, this.store.getState().char, (_d)=>{this.setting( _d )})
        }
        
        if (_newVal==='false') {
            $('#compare').toggle(false);
        }
    }

    setting(_d){
        $('#compare').toggle(true);
        
        $('#pointAbility').hide();
        $('#myCharacterLayer').hide();

        // this.abilitiesDetailViewMe = false;
        // this.abilitiesDetailViewCo = false;

        this.headerMe.setting(_d[0], true, '#compare .compare-header.compare-char-a');
        this.headerCo.setting(_d[3], true, '#compare .compare-header.compare-char-b');

        this.equipMe.setting(_d[1], 'false', '#compare .compare-list.compare-char-a', true);
        this.equipCo.setting(_d[4], 'true', '#compare .compare-list.compare-char-b', true);
        
        this.gemsMe.setting(_d[1], _d[0], 'me', '#compare .compare-list.compare-char-a .gem-wrap');
        this.gemsCo.setting(_d[4], _d[3], 'co', '#compare .compare-list.compare-char-b .gem-wrap');

        this.abilitiesPointMe.setting(_d[2], '#compare .compare-list.compare-char-a .btn-point-Ability', true, _d[5].data);
        this.abilitiesPointCo.setting(_d[5], '#compare .compare-list.compare-char-b .btn-point-Ability', true);
     
        this.abilitiesMe.setting(_d[2], _d[5].data, _d[0].data.clazz, '#compare .compare-list.compare-char-a .ability-view', true);
        this.abilitiesCo.setting(_d[5], null, _d[3].data.clazz, '#compare .compare-list.compare-char-b .ability-view', true);
        
        this.abilitiesDetailViewMe = false;
        this.abilitiesDetailViewCo = false;
    }

    addEvents(){
        $('#compare .btn-close-layer').on('click', e => {
            this.router.goMultiParam({compare: 'false'});
            return false;
        });

        this.abilitiesDetailViewMe = false;
        this.abilitiesDetailViewCo = false;

        $('#compare .compare-char-a .btn-more').on('click', e => {
            this.abilitiesDetailViewMe = !this.abilitiesDetailViewMe;
            $('#compare .compare-list.compare-char-a .ability-view .stat-title').toggleClass('is-active', this.abilitiesDetailViewMe);
            return false;
        });
        $('#compare .compare-char-b .btn-more').on('click', e => {
            this.abilitiesDetailViewCo = !this.abilitiesDetailViewCo;
            $('#compare .compare-list.compare-char-b .ability-view .stat-title').toggleClass('is-active', this.abilitiesDetailViewCo);
            return false;
        });
    }



} // end of class